import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { createFilter } from "react-select";
import { SelectOptions } from "../../../../../../../shared/interfaces/ISelectOptions";
import { Select } from "../../../../../../global";
import { IUF } from "./IInterfaces";

interface Props {
    state: string;
    maxMenuHeight?: number;
}

export const States: React.FC<Props> = ({ state, maxMenuHeight }) => {
    const [options, setOptions] = useState<SelectOptions[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const convertOptions = async (opts: IUF[]) => {
        const selectOptions: SelectOptions[] = [];

        opts.forEach((element: IUF) => {
            const option: SelectOptions = {
                label: element.nome.toUpperCase(),
                value: element.nome.toUpperCase(),
            };
            selectOptions.push(option);
        });
        return selectOptions;
    };

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get<IUF[]>(
                "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
            );
            const op = await convertOptions(response.data);
            setOptions(op);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div>
            {!loading && (
                <Select
                    filterOption={createFilter({
                        ignoreAccents: true,
                        ignoreCase: true,
                    })}
                    defaultValue={{
                        label: state,
                        value: state,
                    }}
                    name="estadoForm"
                    label="ESTADO"
                    placeholder="Clique para selecionar..."
                    options={options}
                    maxMenuHeight={maxMenuHeight || 205}
                    isClearable
                />
            )}
        </div>
    );
};
